var JENDCO_ALGOLIA_BLOCKED_BOT_UA = /baiduspider|ahrefsbot|semrushbot|mj12bot|dotbot|petalbot|blexbot|scrapy|python|curl|wget|headless|phantom|selenium|playwright/i;

if (JENDCO_ALGOLIA_BLOCKED_BOT_UA.test(navigator.userAgent)) {
  console.warn('Algolia disabled for crawler user agent:', navigator.userAgent);
  window.JENDCO_DISABLE_ALGOLIA = true;
}

if (!window.JENDCO_DISABLE_ALGOLIA) {

const headerClient_prod = algoliasearch('SRQQCVINL7','cc4c95e5f685f38dcb80d39dac620913').initIndex('jendco-shopify_products');
const headerClient_popular_search_suggest = algoliasearch('SRQQCVINL7','cc4c95e5f685f38dcb80d39dac620913').initIndex('jendco-shopify_products_query_suggestions');
const headerClient_coll = algoliasearch('SRQQCVINL7','cc4c95e5f685f38dcb80d39dac620913').initIndex('jendco-shopify_collections');
// No InstantSearch here: the dropdown only uses the algoliasearch-lite clients
// above, and the InstantSearch bundle is loaded on collection/search pages only.
let autocompleteContainer = document.querySelector("#header_autocomplete");

function openHeaderSearch(searchElement) {
    const header = document.querySelector('header');
    if (header) {
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom)}px`);
    }
    document.body.classList.add('algolia-header-popup-show');
    searchElement.closest('predictive-search').classList.add('search-open');

    const algoliaClose = document.querySelector('.autocomplete-close');
    if (algoliaClose) {
        algoliaClose.style.display = 'block';
    }
}

function closeHeaderSearch(searchElement) {
    document.body.classList.remove('search-open');
    searchElement.closest('predictive-search').classList.remove('search-open');
}

window.closeAlgoliaHeaderSearch = function(blurInput = false, clearValue = false) {
    const autocompleteContainer = document.querySelector("#header_autocomplete");
    const searchElement = document.querySelector('.header__search predictive-search form .header-search');
    const algoliaClose = document.querySelector('.autocomplete-close');

    if (autocompleteContainer) {
        autocompleteContainer.style.display = 'none';
    }
    if (algoliaClose) {
        algoliaClose.style.display = 'none';
    }
    document.body.classList.remove('algolia-header-popup-show');

    if (searchElement) {
        closeHeaderSearch(searchElement);
        if (clearValue) {
            searchElement.value = "";
        }
        if (blurInput) {
            searchElement.blur();
        }
    }
};

document.querySelector('.autocomplete-close').addEventListener('click', function(e){
    e.preventDefault();
    window.closeAlgoliaHeaderSearch(true, true);
});

document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('algolia-header-popup-show')) {
        window.closeAlgoliaHeaderSearch(true, false);
    }
});

// document.querySelector('.header__search predictive-search form .header-search').addEventListener('focus', function (e) {
//     e.target.closest('predictive-search').classList.add('search-open');
//     document.querySelector('.autocomplete_label.suggest').textContent = 'Popular Searches';

//     headerClient_popular_search_suggest
//     .search("", {hitsPerPage: 3})
//     .then(({ hits, nbHits }) => {
//         document.querySelector('.autocomplete_label.suggest').nextElementSibling.innerHTML = '';
//         hits.forEach((hit) => {
//             document.querySelector('.autocomplete_label.suggest').nextElementSibling.innerHTML += `<li>
//                 <a href="/search?query=${hit.query}" class="search_collection-link__link link link--primary">${hit.query}</a>
//             </li>`;
//         })
//         autocompleteContainer.style.display = 'block';
//         document.querySelector('.autocomplete_label.category').classList.add('!hidden');
//         document.querySelector('.autocomplete_label.category').nextElementSibling.classList.add('!hidden');
//         document.querySelector('.search-products-blogs').classList.add('!hidden');
//     })
    
//     // search_suggestions.addWidgets([
//     //     hits({
//     //         container: document.querySelector('.autocomplete_label.suggest').nextElementSibling,
//     //         templates: {
//     //           item(hit, { html, components }) {
//     //             return `<li><a href="/products/${hit.handle}">${hit.title}</a></li>`;
//     //           }
//     //         }
//     //     })
//     // ])    
// })

// Reusable: populates the dropdown with Popular Searches and resets the
// "no results" / product-results sections. Called on input focus AND when
// the user clears the search bar while still focused.
function showPopularSearches() {
    document.querySelector('.autocomplete_label.suggest').textContent = 'Popular Searches';

    // Clear any stale "no results" message and product-results state
    // left over from a previous search.
    const noResultEl = document.querySelector('.no-result');
    if (noResultEl) {
        noResultEl.classList.add('!hidden');
        noResultEl.textContent = '';
    }
    const wrapper = document.querySelector('.autocomplete_wrapper');
    if (wrapper) wrapper.classList.remove('!hidden');

    headerClient_popular_search_suggest
    .search("", {hitsPerPage: 3})
    .then(({ hits, nbHits }) => {
        document.querySelector('.autocomplete_label.suggest').nextElementSibling.innerHTML = '';
        hits.forEach((hit) => {
            document.querySelector('.autocomplete_label.suggest').nextElementSibling.innerHTML += `<li>
                <a href="/search?query=${hit.query}" class="search_collection-link__link link link--primary">${hit.query}</a>
            </li>`;
        })
        autocompleteContainer.style.display = 'block';
        document.querySelector('.autocomplete_label.category').classList.add('!hidden');
        document.querySelector('.autocomplete_label.category').nextElementSibling.classList.add('!hidden');
        document.querySelector('.search-products-blogs').classList.add('!hidden');
    })
}

window.onscroll = function() {
    if (window.scrollY > 100 && autocompleteContainer.style.display == 'block') {
        autocompleteContainer.style.display = 'none';
    }
};

document.querySelector('.header__search predictive-search').addEventListener('focusout', function (e) {
    if (!this.contains(e.relatedTarget) && document.body.classList.contains('algolia-header-popup-show')) {
        window.closeAlgoliaHeaderSearch(false, false);
    } else if (!document.body.classList.contains('algolia-header-popup-show') && autocompleteContainer.style.display !== 'block') {
        const searchElement = document.querySelector('.header__search predictive-search form .header-search');
        if (searchElement) closeHeaderSearch(searchElement);
    }
})

document.querySelector('.header__search predictive-search form .header-search').addEventListener('focus', function (e) {
    openHeaderSearch(e.target);
    showPopularSearches();
})

document.querySelector('.header__search predictive-search form .header-search').addEventListener('input', function(e) {

    var count_prod = 0;
    openHeaderSearch(this);

  if(this.value.length > 1){
    headerClient_prod
        .search(this.value, {
            hitsPerPage: 6,
            distinct: true,
            /* Catalogue visibility. Applies to guests too, so company
             * exclusives stay out of the public dropdown. */
            filters: (function () {
        if (typeof window.jendcoB2BFilter === 'function') return window.jendcoB2BFilter();
        var l = window.algoliaB2B && (window.algoliaB2B.locationId || window.algoliaB2B.rawLocationId);
        var a = 'meta.custom.b2b_location_ids';
        return ['tags:"b2b-only"', a + ':"restricted"'].map(function (m) {
          return l ? '(NOT ' + m + ' OR ' + a + ':"' + l + '")' : 'NOT ' + m;
        }).join(' AND ');
      })()
          })
        .then(({ hits, nbHits }) => {
            console.log(hits,hits.length,'hit',count_prod)
            var autolist = ``;
            document.querySelectorAll('.mega-nav.open, .brands.open').forEach((ele) => ele.classList.remove('open'));
            hits.forEach((hit) => {                
                let prod_image = "https://cdn.shopify.com/s/files/1/0576/7803/7155/files/imageless.jpg";
                let prod_title = hit.title;
                var mpn_val = '';
                const algoliaData = (hit.meta && hit.meta.custom && hit.meta.custom.algolia_data) || {};
                if(algoliaData.mpn){
                    mpn_val = `<div class="autocomplete_mpn">MPN: ${algoliaData.mpn}</div>`;
                }
                if(hit.image){
                    prod_image = hit.image;
                }
                if(hit.image){
                    prod_image = hit.image;
                }
                autolist += `
                <li class="autocomplete_result">
                        <div class="autocomplete_image"><img src="${prod_image}" class="autocomplete_image" /></div>
                        <div class="content">
                            <a href="/products/${hit.handle}" class="autocomplete_title">${prod_title}</a>
                            <div class="autocomplete_sku">SKU: ${hit.sku}</div>${mpn_val}
                            <div class="autocomplete_price">${FoxTheme.Currency.formatMoney(hit.price * 100,theme.moneyFormat)}</div>
                        </div>
                </li>`;
            });
            
            // autocompleteContainer.innerHTML = `<div class="autocomplete_label">Suggestions...</div>`;
            if(hits.length > 0){
                document.querySelector('.no-result').classList.add('!hidden');
                document.querySelector('.autocomplete_label.suggest').textContent = 'Suggested Searches';
                document.querySelector('.search-products-blogs').classList.remove('!hidden');
                count_prod = nbHits;
                autocompleteContainer.querySelector('.search-product #hits').innerHTML = autolist;
                autocompleteContainer.querySelector('.search-product .autocomplete_label').textContent = `${nbHits} results for ${this.value}`;
                autocompleteContainer.querySelector('.search-product .autocomplete_label').classList.remove('!hidden');
                if(nbHits > 6){
                    autocompleteContainer.querySelector('.search-product .view-all-links').classList.remove('!hidden');
                }else{
                    autocompleteContainer.querySelector('.search-product .view-all-links').classList.add('!hidden');
                }
                document.querySelector('.autocomplete_wrapper').classList.remove('!hidden');
            }else{
                autocompleteContainer.querySelector('.search-product #hits').innerHTML = `<li>No Results Found</li>`;
                autocompleteContainer.querySelector('.search-product .view-all-links').classList.add('!hidden');
                autocompleteContainer.querySelector('.search-product .autocomplete_label').classList.add('!hidden');
            }
            autocompleteContainer.style.display = 'block';
            document.body.classList.add('algolia-header-popup-show')
        })
        .catch(err => {
            console.log(err);
        });

    headerClient_coll
        .search(this.value, {
            hitsPerPage: 3,
            distinct: true
          })
        .then(({ hits }) => { 
            console.log(hits,hits.length,'hitcoll',count_prod)
            var autolist = ``;
            document.querySelectorAll('.mega-nav.open, .brands.open').forEach((ele) => ele.classList.remove('open'));
            hits.forEach((hit) => {
                autolist += `<li><a href="/collections/${hit.handle}">${hit.title}</a></li>`;
            });
            // autocompleteContainer.innerHTML = `<div class="autocomplete_label">Suggestions...</div>`;
            if(hits.length > 0){
                document.querySelector('.autocomplete_label.category').classList.remove('!hidden');
                document.querySelector('.autocomplete_label.category').nextElementSibling.classList.remove('!hidden');
                autocompleteContainer.querySelector('.search-category #categories').innerHTML = autolist;
                autocompleteContainer.querySelector('.search-category .autocomplete_label.category').classList.remove('!hidden');
                document.querySelector('.autocomplete_wrapper').classList.remove('!hidden');
                document.querySelector('.no-result').classList.add('!hidden');
            }else{
                autocompleteContainer.querySelector('.search-category #categories').innerHTML = `<li>No Results Found</li>`;
                autocompleteContainer.querySelector('.search-category .autocomplete_label.category').classList.add('!hidden');
                if(count_prod == 0){
                    document.querySelector('.no-result').classList.remove('!hidden');
                    document.querySelector('.no-result').textContent = `No results found for “${this.value}”. Check the spelling or use a different word or phrase.`;
                    document.querySelector('.autocomplete_wrapper').classList.add('!hidden');
                }else{
                    document.querySelector('.no-result').classList.add('!hidden');
                    document.querySelector('.autocomplete_wrapper').classList.remove('!hidden');
                }
            }
            autocompleteContainer.style.display = 'block';
            document.body.classList.add('algolia-header-popup-show')
        })
        .catch(err => {
            console.log(err);
        });
  }else{
    if (this.value.length === 0 && document.activeElement === this) {
        showPopularSearches();
      } else {
        autocompleteContainer.style.display = 'none';
      }
  }
});


function submitForm(ele){
    ele.closest('form').submit();
  }

window.onpageshow = function(event) {
    if (event.persisted && document.body.classList.contains('algolia-header-popup-show')) {
        window.closeAlgoliaHeaderSearch(true, false);
    }
};
}
